<template>
  <div class="confirmation-modal-overlay">
    <div class="confirmation-modal">
      <div class="modal-header">
        <h2 class="title">
          {{ title }}
        </h2>
        <p class="subtitle">
          {{ message }}
        </p>
      </div>

      <div class="modal-footer">
        <rectoplus-button-outlined
          class="cancel-button"
          :text="cancelText"
          @click="$emit('cancel')"
        />
        <rectoplus-button
          class="confirm-button"
          :text="confirmText"
          @click="$emit('confirm')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import RectoplusButton from '@/components/buttons/RectoplusButton.vue';
import RectoplusButtonOutlined from '@/components/buttons/RectoplusButtonOutlined.vue';

export default {
  name: 'ConfirmationModal',
  components: {
    RectoplusButton,
    RectoplusButtonOutlined,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    message: {
      type: String,
      required: true,
    },
    confirmText: {
      type: String,
      required: true,
    },
    cancelText: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.confirmation-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: $modal_overlay;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.confirmation-modal {
  background: $color_light;
  border-radius: 8px;
  padding: 20px;
  width: 90%;
  max-width: 500px;
  box-shadow: 0 2px 10px $modal_shadow;

  .modal-header {
    margin-bottom: 20px;

    .title {
      margin: 0;
      font-weight: 600;
      text-align: center;
      font-size: 1.5em;
    }

    .subtitle {
      margin: 10px 0 0;
      font-size: 1em;
      text-align: center;
    }
  }

  .modal-footer {
    display: flex;
    justify-content: space-between;
    gap: 10px;

    .cancel-button,
    .confirm-button {
      flex: 1;
    }
  }
}
</style>
